import React from "react";

interface CurrencyGTCellProps {
  value: number;
}

const CurrencyGTCell: React.FC<CurrencyGTCellProps> = ({ value }) => {
  const formattedValue = new Intl.NumberFormat("es-GT", {
    style: "currency",
    currency: "GTQ",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value ?? 0);

  return <span>{formattedValue}</span>;
};

export default CurrencyGTCell;
